import { PageLink, PageTitle } from "_metronic/layout/core";
import { absolutePath } from "app/helpers/relativePath";
import { FC, useEffect } from "react";
import { connect } from "react-redux";
import { adminHomePage } from "../main/admin/AdminMain";
import { emptyObject } from "app/helpers/helperFunction";
import UsersListSearchComponent from "app/components/commonComponent/table/UsersListSearchComponent";
import { useGetSearchObject } from "app/helpers/customHooks";
import Table from "app/components/commonComponent/table/Table";
import { getTaskTimeReportList } from "app/reducers/task/taskAction";
import { searchParams } from "app/helpers/commonInterface";
import { TASK_TIME_REPORT_LIST } from "app/helpers/routes";
import { KTCard } from "_metronic/helpers";
import TaskFilter from "./component/TaskFilter";
import { taskTimeReportListState } from "app/reducers/task/getTaskTimeReportListReducer";
import TaskTimeReportTableRow from "./component/TaskTimeReportTableRow";
import TaskTimeFilter from "./component/TaskTimeFilter";

interface props {
  taskTimeReportDetails: taskTimeReportListState;
  getTaskTimeReportListDispatch: Function;
}

export const taskTimeReportListPage = {
  title: "Task Time Report",
  path: absolutePath(TASK_TIME_REPORT_LIST),
  isSeparator: true,
  isActive: true,
};

const accountBreadCrumbs: Array<PageLink> = [adminHomePage, emptyObject];

const TaskTimeReportList: FC<props> = ({
  getTaskTimeReportListDispatch,
  taskTimeReportDetails,
}) => {

  const HEADERS = [
    { columnName: "Task Code", id: "TaskCode", className: "min-w-125px ps-2" },
    { columnName: "Task", id: "TypeName", className: "min-w-125px" },
    { columnName: "Standard Hours", id: "StandardHours", className: "min-w-125px" },
    { columnName: "Taken Hours", id: "TakenHours", className: "min-w-125px" },
    { columnName: "Variation", id: "Variation", className: "min-w-125px" }
  ];

  const { searchObj } = useGetSearchObject();

  useEffect(() => {
    getTaskTimeReportListDispatch(searchObj);
  }, [searchObj]);

  return (
    <>
      <PageTitle breadcrumbs={accountBreadCrumbs}>Task-Time</PageTitle>
      <div className="d-flex justify-content-end align-items-center flex-wrap gap-3 mb-4 position-relative">
        <UsersListSearchComponent />
        <TaskTimeFilter />
      </div>
      <KTCard>
        <Table
          checkBoxColumn={{ show: false }}
          error={taskTimeReportDetails.error}
          headers={HEADERS}
          success={taskTimeReportDetails.taskTimeDetails?.success}
          loading={taskTimeReportDetails.loading}
          paginate={{
            show: true,
            pagination: taskTimeReportDetails.taskTimeDetails?.pagination,
            PageNumber: Number(searchObj.PageNumber || 1),
            PageSize: Number(searchObj.PageSize) || 10,
          }}
          tableData={taskTimeReportDetails.taskTimeDetails?.data?.records}
          tableRow={(row: any, index: number) => (
            <TaskTimeReportTableRow row={row} key={`row-${index}-${row.id}`} />
          )}
        />
      </KTCard>
    </>
  );
};

const mapStateToProps = (state: any) => {
  return {
    taskTimeReportDetails: state.taskTimeReportDetails,
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    getTaskTimeReportListDispatch: (searchObj: searchParams) =>
      dispatch(getTaskTimeReportList(searchObj)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TaskTimeReportList);
